import { render, staticRenderFns } from "./hedge.vue?vue&type=template&id=90f0fb6e&scoped=true&"
import script from "./hedge.vue?vue&type=script&lang=ts&"
export * from "./hedge.vue?vue&type=script&lang=ts&"
import style0 from "./hedge.vue?vue&type=style&index=0&id=90f0fb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f0fb6e",
  null
  
)

export default component.exports